import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import * as React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useParams } from "react-router-dom";

import { AuditLogsUrlQueryParams } from "./urls";
import AuditLogsExpressFleetView from "./views/AuditLogsExpressFleet";
import AuditLogsShippingRateView from "./views/AuditLogsShippingRate";

const AuditLogsLocationRateComponent: React.FC = () => {
  const { id } = useParams();
  const qs = parseQs(location.search.substring(1));
  const params: AuditLogsUrlQueryParams = qs;
  return (
    <AuditLogsShippingRateView
      id={decodeURIComponent(id)}
      params={params}
      pageName="Location Range Rates - Activity Logs"
      type="LOCATION"
      cardTitle="Shipping Events"
    />
  );
};

const AuditLogsPriceRateComponent: React.FC = () => {
  const { id } = useParams();
  const qs = parseQs(location.search.substring(1));
  const params: AuditLogsUrlQueryParams = qs;
  return (
    <AuditLogsShippingRateView
      id={decodeURIComponent(id)}
      params={params}
      pageName="Price Based Rates - Activity Logs"
      type="PRICE"
      cardTitle="Price Rate Events"
    />
  );
};

const AuditLogsExpressFleetComponent: React.FC = () => {
  const qs = parseQs(location.search.substring(1));
  const params: AuditLogsUrlQueryParams = qs;
  return (
    <AuditLogsExpressFleetView
      params={params}
      pageName="Express Fleet - Activity Logs"
      cardTitle="Express Fleet Events"
    />
  );
};

const AuditLogsMallExpressFleetComponent: React.FC = () => {
  const { id } = useParams();
  const qs = parseQs(location.search.substring(1));
  const params: AuditLogsUrlQueryParams = qs;
  const mallName = " in " + params.mall || "-";
  return (
    <AuditLogsExpressFleetView
      id={decodeURIComponent(id)}
      params={params}
      pageName="Express Fleet - Activity Logs"
      cardTitle={"Express Fleet Events" + mallName}
    />
  );
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.expressFleet)} />
      <Routes>
        <Route
          path={"location-rate/:id"}
          element={<AuditLogsLocationRateComponent />}
        />
        <Route
          path={"price-rate/:id"}
          element={<AuditLogsPriceRateComponent />}
        />
        <Route
          path={"express-fleet/:id"}
          element={<AuditLogsMallExpressFleetComponent />}
        />
        <Route
          path={"express-fleet"}
          element={<AuditLogsExpressFleetComponent />}
        />
      </Routes>
    </>
  );
};

export default Component;
